/**
 * Fluid cursor effect — math helpers
 * Inspired by PavelDoGreat/WebGL-Fluid-Simulation and faraasat/smokey-fluid-cursor
 * (minimal extracted implementation)
 */

export function clamp01(v) {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

export function scaleByPixelRatio(v, maxDpr) {
  const dpr = Math.min(window.devicePixelRatio || 1, maxDpr);
  return Math.floor(v * dpr);
}

export function getResolution(gl, resolution) {
  let aspectRatio = gl.drawingBufferWidth / gl.drawingBufferHeight;
  if (aspectRatio < 1) aspectRatio = 1.0 / aspectRatio;
  const min = Math.round(resolution);
  const max = Math.round(resolution * aspectRatio);
  if (gl.drawingBufferWidth > gl.drawingBufferHeight) {
    return { width: max, height: min };
  }
  return { width: min, height: max };
}

export function correctDeltaX(delta, canvas) {
  const aspectRatio = canvas.width / canvas.height;
  if (aspectRatio < 1) return delta * aspectRatio;
  return delta;
}

export function correctDeltaY(delta, canvas) {
  const aspectRatio = canvas.width / canvas.height;
  if (aspectRatio > 1) return delta / aspectRatio;
  return delta;
}

export function correctRadius(radius, canvas) {
  const aspectRatio = canvas.width / canvas.height;
  if (aspectRatio > 1) return radius * aspectRatio;
  return radius;
}
